import VelkieLayout from "../VelkieLayout";
import { useEffect, useRef } from "react";

import { useParams } from "react-router-dom";
import { isEmpty } from "lodash";
import LiveMatchTrackerCricket from "../../Score/Cricket/ScoerBoardDetail";
import { formatNumber } from "../../../Utils/Toast";
import { useTabIndicator } from "../../../component/useTabIndicator";

import SportBook from "./SportBook";
import BetSlipVelkie from "../BetSlipVelkie";
import Widgets from "./Widgets";
import LoadingImage from "../../../assets/images/cover-live.webp";
import ReactPlayer from "react-player";
import ParlaySportBook from "./ParlaySportBook";
import BookPosition from "../../matchDetail/BookPosition";
import SelectionVelkie from "./SelectionVelkie";
import FancyVelkie from "./FancyVelkie";
import BookmakerVelkie from "./BookmakerVelkie";
import { useMatchDetailLogic } from "../../useLogic/useMatchDetailLogic";
const Detail = () => {
  const parmas = useParams();
  const ref = useRef(null);
  const {
    // context
    user,
    profileData,
    showBetDialog,
    betSlipObject,
    setBetSlipObject,

    // state
    fancyModal,
    setFancyModal,
    loading,
    setLoading,
    mute,
    tvClass,
    setTvClass,
    fancyTab,
    setFancyTab,
    marketNew,
    marketName,
    setMarketName,
    marketId,
    setMarketId,
    detail,
    bookmakerOdds,
    sportsBookPosition,
    bookmaker,
    fancy,
    sportsBook,
    fancyPosition,
    runner,
    setRunner,
    runnerOdds,
    fancyHeader,
    favouriteList,
    loader,

    // functions
    getBetPosition,
    getMatchOdds,
    addToFavioute,

    // memoized
    totalMatched,
    backOdds,
    layOdds,
    backOddsBookmaker,
    layOddsBookmaker,
    oldBack,
    oldLay,
    oldBackBookmaker,
    oldLayBookmaker,
    ms,
    positionMemo,
    positionMemoBookmaker,
    profileDataMemo,

    activeTab,
    setActiveTab,
    score,
    showSportbook,
    showFancy,
  } = useMatchDetailLogic();
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      // Check if scroll is past 200px and page height > 1200
      if (showBetDialog) {
        setTvClass(false);
        // setActiveTab("scoreboard");
      } else {
        if (scrollY >= 130 && pageHeight > 1000) {
          setTvClass(true);
        } else {
          setTvClass(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Initial check in case user is already scrolled
    handleScroll();

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showBetDialog]);
  const displayScore = () => {
    return (
      <div data-v-69898ddf className="video-wrapper relative z-0">
    
       
          <iframe
            data-v-69898ddf
            style={{ width: "100%", height: "270px" }}
            className="w-full aspect-video relative"
            src={detail?.scoreUrl}
          />
      
      </div>
    );
  };

  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);
  const tabsBottom = [
    showFancy && { id: "Fancy", label: "Fancybet" },
    showSportbook && { id: "Premium", label: "Sportsbook" },
  ].filter(Boolean);
  const tabs =
    !isEmpty(user) && detail?.status == "in_play"
      ? [
          { id: "live", label: "Live" },
          { id: "scoreboard", label: "Scoreboard" },
        ]
      : [{ id: "scoreboard", label: "Scoreboard" }];
  return (
    <VelkieLayout visibilityType={true}>
      <main className="min-h-full-with-header">
        <div data-v-fa12c4fa className>
          {/* pb-90px */}
          <div className="relative ">
            <div>
              <div
                data-v-46787094
                className="h-36px relative flex justify-center items-center bg-black"
                style={{
                  "--75265984":
                    !isEmpty(user) && detail?.status == "in_play"
                      ? activeTab == "live"
                        ? `24px`
                        : " 68px"
                      : "80px",
                  "--33d33e52": `translateX(${
                    !isEmpty(user) && detail?.status == "in_play"
                      ? activeTab == "live"
                        ? "78"
                        : "236"
                      : "140"
                  }px)`,
                }}
              >
                <div className="flex justify-center items-center w-full">
                  {tabs.map((tab, index) => (
                    <div
                      key={tab.id}
                      onClick={() => {
                        setActiveTab(tab.id);
                      }}
                      className={`text-center w-1/2 cursor-pointer ${
                        activeTab === tab.id ? "bg-blue-600" : "bg-transparent"
                      }`}
                    >
                      <span
                        className={`text-13 text-center font-bold text-white
                        `}
                      >
                        {tab.label}
                      </span>
                    </div>
                  ))}
                </div>
                <div
                  data-v-46787094
                  className="tab-indicator absolute left-0 bottom-1 rounded-full bg-white"
                />
              </div>

              <div
                data-v-817f0143
                className="py-1.5 px-4 min-h-40px flex justify-center items-center bg-white"
              >
                <div
                  data-v-817f0143
                  className="sub-row w-full grid items-center"
                >
                  <div
                    data-v-817f0143
                    className="flex justify-start items-center"
                  >
                    <h2
                      data-v-817f0143
                      className="w-3/4 text-13 break-words text-left"
                    >
                      {detail?.eventName?.split(" v ")[0]}
                    </h2>
                    {!isEmpty(score) && (
                      <span
                        data-v-817f0143
                        className="ml-2 text-13 text-widget-text font-bold"
                      >
                        {score?.split("-")[0]}
                      </span>
                    )}
                  </div>
                  <span
                    data-v-817f0143
                    className="text-13 text-widget-text font-bold text-center"
                  >
                    -
                  </span>
                  <div
                    data-v-817f0143
                    className="flex justify-end items-center"
                  >
                    {!isEmpty(score) && (
                      <span
                        data-v-817f0143
                        className="mr-2 text-13 text-widget-text font-bold"
                      >
                        {score?.split("-")[1]}
                      </span>
                    )}
                    <h2
                      data-v-817f0143
                      className="w-3/4 text-13 text-right break-words"
                    >
                      {detail?.eventName?.split(" v ")[1]}
                    </h2>
                  </div>
                </div>
              </div>
              <div className="bg-secondary" style={{ height: "auto" }}>
                {activeTab == "scoreboard" &&
                  !["horse", "greyhound"].includes(parmas?.type) &&
                  !isEmpty(detail?.scoreId) &&
                  detail?.scoreId != "false" && (
                    <div data-v-69898ddf className="video-contaienr relative">
                      {displayScore()}
                    </div>
                  )}

                {!["horse", "greyhound"].includes(parmas?.type) &&
                activeTab == "live" &&
                !isEmpty(user) &&
                detail?.channel !== "false" &&
                detail?.status == "in_play" ? (
                  <div
                    className="video-contaienr relative"
                    style={{ height: loading ? "200px" : "auto" }}
                  >
                    <div data-v-4500b3c2 className="video-wrapper relative z-0">
                      {loading && (
                        <img
                          src={LoadingImage}
                          alt="Thumbnail"
                          className="w-full aspect-video relative"
                          width={"100%"}
                          style={{
                            padding: "0",
                            position: "absolute",
                            margin: "0",
                            width: "100%",
                            height: "200px",
                          }}
                        />
                      )}

                      <div
                        style={!tvClass ? { display: "none" } : {}}
                        onClick={() => setActiveTab("scoreboard")}
                        data-v-69898ddf
                        className="btn-close w-10 h-10 absolute right-5 top-3 z-50 flex justify-center items-center rounded-full"
                      >
                        <span
                          data-v-69898ddf
                          className="icon-close text-16px text-white"
                        />
                      </div>

                      <ReactPlayer
                        muted={mute}
                        data-v-4500b3c2
                        controls={false}
                        ref={ref}
                        playsinline={true}
                        loop={true}
                        playing={true}
                        id="videoFrame"
                        className="s-w-full s-aspect-video s-relative s-z-0"
                        onReady={() => setLoading(false)} // Video is ready → hide loader
                        onBuffer={() => setLoading(true)} // When buffering → show loader
                        onBufferEnd={() => setLoading(false)} // Buffer ends → hide loader
                        width={375}
                        height="100%"
                        url={`https://cceucceu.cc/${detail.channel}/index.m3u8`}
                        config={{
                          youtube: {
                            playerVars: {
                              showinfo: 1,
                              fs: 1,
                              controls: 1,
                            },
                          },

                          file: {
                            attributes: {
                              preload: "none",
                              crossOrigin: "true",
                            },
                            hlsOptions: {
                              startLevel: 3,
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            {isEmpty(parmas?.type) ? (
              <div className="px-2 mb-12">
                <div>
                  <div className="-mx-2 px-2 h-34px flex justify-between items-center bg-black">
                    <p className="text-base text-white">Exchange</p>
                    <div className="flex justify-center items-center">
                      <span className="mr-1 text-10 text-market-exchange-tip opacity-85">
                        Matched
                      </span>
                      <span className="text-10 text-market-exchange-tip font-bold">
                        BDT {formatNumber(runnerOdds?.totalMatched) || 0.0}
                      </span>
                    </div>
                  </div>
                  {marketNew?.length > 0 && detail?.matchOdds == "on" && (
                    <div
                      data-v-7813dccc
                      className="-mx-2 market-wrapper h-34px relative bg-primary overflow-y-hidden overflow-x-scroll"
                      style={{
                        "--d9ac4036": `${indicatorStyle?.width || 100}px`,
                        "--58a67a32": `translateX(${indicatorStyle?.x + 10}px)`,
                      }}
                    >
                      <div data-v-7813dccc className="h-full inline-block">
                        <ul
                          ref={containerRef}
                          data-v-7813dccc
                          className="ml-2 mr-1 h-full flex flex-nowrap justify-start items-center text-market-name"
                        >
                          {marketNew?.map((res, index) => {
                            let animate = !isEmpty(
                              detail?.favourites?.find((obj) => {
                                return res?.marketId == obj?.favoriteMarketId;
                              }),
                            );
                            return (
                              <li
                                onClick={(e) => {
                                  {
                                    setMarketName(res?.market);
                                    setActiveIndex(index);
                                    getMatchOdds(res?.marketId);
                                    getBetPosition(res?.marketId);
                                    setRunner(res?.jsonData);
                                    setMarketId(res?.marketId);
                                  }
                                }}
                                data-v-7813dccc
                                className="mr-15px h-full flex items-center whitespace-nowrap -translate-x-1.5"
                              >
                                <div
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    addToFavioute(
                                      detail?.eventId,
                                      "Match Odds",
                                      res?.marketId,
                                      res?.market,
                                    );
                                  }}
                                  data-v-117db823
                                  data-v-7813dccc
                                  className="w-8 h-6 flex justify-center items-center"
                                  style={{
                                    "--b64d5fc0": "0.4363636363636363",
                                    "--3cad14f0": "-0.9375rem",
                                  }}
                                >
                                  <div
                                    data-v-117db823
                                    className={`fave ${
                                      animate ? "animate" : ""
                                    }  bg-star-sprit-black-webp`}
                                  />
                                </div>
                                <span data-v-7813dccc className="text-base">
                                  {res?.market}
                                </span>
                              </li>
                            );
                          })}
                        </ul>

                        <div
                          data-v-7813dccc
                          className="tab-indicator absolute left-0.5 bottom-1 rounded-full bg-market-name"
                        />
                      </div>
                    </div>
                  )}
                  {detail?.matchOdds == "on" && runner?.length > 0 && (
                    <SelectionVelkie
                      runner={runner}
                      name={marketName}
                      marketId={marketId}
                      totalMatched={totalMatched}
                      backOdds={backOdds}
                      layOdds={layOdds}
                      oldBack={oldBack}
                      oldLay={oldLay}
                      detail={detail}
                      ms={ms}
                      position={positionMemo}
                      profileData={profileDataMemo}
                      typeGame="betFaire"
                      marketName={marketName}
                      user={user}
                      addToFavioute={addToFavioute}
                    />
                  )}
                </div>

                {detail?.bookMaker == "on" &&
                  (detail?.gameType == "cricket" || detail?.hasBookmaker) &&
                  bookmaker?.length > 0 && (
                    <BookmakerVelkie
                      runner={bookmaker}
                      marketId={parmas?.marketId}
                      detail={detail}
                      backOdds={backOddsBookmaker}
                      layOdds={layOddsBookmaker}
                      oldBack={oldBackBookmaker}
                      oldLay={oldLayBookmaker}
                      ms={detail?.bookMaker == "on" ? bookmakerOdds?.ms : 3}
                      position={positionMemoBookmaker}
                      profileData={profileDataMemo}
                      addToFavioute={addToFavioute}
                      typeGame="bookmaker"
                      marketName={"Bookmaker"}
                      user={user}
                    />
                  )}
                {tabsBottom?.length > 0 && (
                  <div className="mt-2 fullmarket-bottom">
                    <section className="p-2 pb-0 bg-secondary rounded-t-xl -mb-px">
                      <div className="flex rounded-t-md overflow-hidden bg-market-tab w-max">
                        {tabsBottom.map((tab, idx) => (
                          <div
                            key={tab.id}
                            onClick={() => setFancyTab(tab.id)}
                            className={`relative text-14 w-100px cursor-pointer`}
                          >
                            <div
                              className={`h-8 py-2 rounded-t-md ${
                                fancyTab === tab.id
                                  ? "bg-market-tab-active"
                                  : ""
                              }`}
                            />

                            <span
                              className={`absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 ${
                                fancyTab === tab.id
                                  ? "text-market-tab-text"
                                  : "text-market-tab-active"
                              }`}
                            >
                              {tab.label}
                            </span>
                          </div>
                        ))}
                      </div>
                    </section>
                    {fancyTab == "Fancy" &&
                      parmas?.type != "multi" &&
                      showFancy && (
                        <FancyVelkie
                          fancy={fancy}
                          detail={detail}
                          fancyHeader={fancyHeader}
                          position={fancyPosition}
                          typeGame={"fancy"}
                          profileData={
                            detail?.matchSetting?.length > 0
                              ? {
                                  ...detail,
                                  arrayCheck: "details",
                                  profile: profileData,
                                }
                              : {
                                  ...profileData,
                                  arrayCheck: "profile",
                                  profile: profileData,
                                }
                          }
                          setFancyModal={setFancyModal}
                          addToFavioute={addToFavioute}
                          favouriteList={favouriteList}
                        />
                      )}
                    {(parmas?.type == "multi" ? true : fancyTab == "Premium") &&
                      showSportbook && (
                        <SportBook
                          data={sportsBook}
                          user={user}
                          favouriteList={favouriteList}
                          detail={detail}
                          position={sportsBookPosition}
                          setBetSlipObject={setBetSlipObject}
                          betSlipObject={betSlipObject}
                          BetSlip={BetSlipVelkie}
                          profileData={
                            detail?.matchSetting?.length > 0
                              ? {
                                  ...detail,
                                  arrayCheck: "details",
                                }
                              : {
                                  ...profileData,
                                  arrayCheck: "profile",
                                }
                          }
                          addToFavioute={addToFavioute}
                        />
                      )}
                  </div>
                )}
              </div>
            ) : (
              <ParlaySportBook
                data={sportsBook}
                user={user}
                favouriteList={favouriteList}
                detail={detail}
                position={sportsBookPosition}
                setBetSlipObject={setBetSlipObject}
                betSlipObject={betSlipObject}
                BetSlip={BetSlipVelkie}
                profileData={
                  detail?.matchSetting?.length > 0
                    ? {
                        ...detail,
                        arrayCheck: "details",
                      }
                    : {
                        ...profileData,
                        arrayCheck: "profile",
                      }
                }
                addToFavioute={addToFavioute}
              />
            )}

            {!isEmpty(fancyModal?.object) && fancyModal?.status && (
              <BookPosition
                object={fancyModal?.object}
                setFancyModal={setFancyModal}
              />
            )}
            <Widgets detail={detail} />
          </div>
        </div>
      </main>{" "}
    </VelkieLayout>
  );
};

export default Detail;
